import React from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import LogoMark from './LogoMark';
import { agencyInfo } from '../data/mock';

/**
 * StudioHeader — Header exclusivo da preview /studio.
 * Usa a paleta cobalto (Studio) e é isolado do Header da agência.
 */
const StudioHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const scrollToSection = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0B0B0F]/95 backdrop-blur-md border-b border-white/10">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/studio" className="flex items-center" data-testid="studio-header-logo">
            <LogoMark className="text-xl md:text-2xl" showTagline={true} />
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} data-testid="snav-home" className="text-white hover:text-[#2540A3] transition-colors font-medium text-sm uppercase tracking-wider">Início</button>
            <button onClick={() => scrollToSection('possibilidades')} data-testid="snav-possibilidades" className="text-white hover:text-[#2540A3] transition-colors font-medium text-sm uppercase tracking-wider">O Espaço</button>
            <button onClick={() => scrollToSection('cenarios')} data-testid="snav-cenarios" className="text-white hover:text-[#2540A3] transition-colors font-medium text-sm uppercase tracking-wider">Cenários</button>
            <button onClick={() => scrollToSection('experiencia')} data-testid="snav-experiencia" className="text-white hover:text-[#2540A3] transition-colors font-medium text-sm uppercase tracking-wider">Experiência</button>
            <button onClick={() => scrollToSection('waitlist')} data-testid="snav-waitlist" className="text-[#F59E0B] hover:text-white transition-colors font-bold text-sm uppercase tracking-wider">Lançamento 2027</button>
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <a href={`tel:${agencyInfo.phone}`} className="flex items-center space-x-2 text-white hover:text-[#2540A3] transition-colors">
              <Phone className="w-4 h-4" />
              <span className="text-sm">{agencyInfo.phone}</span>
            </a>
          </div>

          <button onClick={() => setIsMenuOpen(!isMenuOpen)} data-testid="studio-menu-toggle" className="md:hidden text-white hover:text-[#2540A3] transition-colors">
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/10 pt-4">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('home')} className="text-white hover:text-[#2540A3] transition-colors text-left font-medium text-sm uppercase tracking-wider">Início</button>
              <button onClick={() => scrollToSection('possibilidades')} className="text-white hover:text-[#2540A3] transition-colors text-left font-medium text-sm uppercase tracking-wider">O Espaço</button>
              <button onClick={() => scrollToSection('cenarios')} className="text-white hover:text-[#2540A3] transition-colors text-left font-medium text-sm uppercase tracking-wider">Cenários</button>
              <button onClick={() => scrollToSection('experiencia')} className="text-white hover:text-[#2540A3] transition-colors text-left font-medium text-sm uppercase tracking-wider">Experiência</button>
              <button onClick={() => scrollToSection('waitlist')} className="text-[#F59E0B] hover:text-white transition-colors text-left font-bold text-sm uppercase tracking-wider">Lançamento 2027</button>
              <div className="flex flex-col space-y-3 pt-4 border-t border-white/10">
                <a href={`tel:${agencyInfo.phone}`} className="flex items-center space-x-2 text-white hover:text-[#2540A3] transition-colors">
                  <Phone className="w-4 h-4" />
                  <span className="text-sm">{agencyInfo.phone}</span>
                </a>
                <a href={`mailto:${agencyInfo.email}`} className="flex items-center space-x-2 text-white hover:text-[#2540A3] transition-colors">
                  <Mail className="w-4 h-4" />
                  <span className="text-sm">{agencyInfo.email}</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default StudioHeader;
